import React from 'react';

interface DeleteChatModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  chatTitle: string;
  isDeleting?: boolean;
}

/* 旧 styled-components 定義をクラス文字列定数として保持。
 * 旧 `@keyframes slideIn`（opacity 0 / translateY(-20px) → 1 / 0）は
 * globals.css の既存 `em-slide-in` と同内容なのでそれを再利用する。 */
const MODAL_BACKDROP =
  'fixed top-0 left-0 right-0 bottom-0 bg-black/50 flex items-center justify-center ' +
  'z-[10000] backdrop-blur-[2px]';

const MODAL_CONTENT =
  'bg-white rounded-tasky-md w-[90%] max-w-[480px] ' +
  'shadow-[0_20px_25px_-5px_rgba(0,0,0,0.1),0_10px_10px_-5px_rgba(0,0,0,0.04)] ' +
  'animate-[em-slide-in_0.2s_ease-out]';

const MODAL_HEADER = 'p-6 border-b border-b-gray-200'; /* #E5E7EB */

const MODAL_TITLE = 'text-[1.25rem] font-semibold text-gray-900 m-0 flex items-center gap-2'; /* #111827 */

const WARNING_ICON = 'text-[1.5rem]';

const MODAL_BODY = 'p-6';

const MESSAGE = 'text-[0.9375rem] text-gray-700 m-0 mb-4 leading-[1.6]'; /* #374151 */

const CHAT_TITLE = 'font-semibold text-gray-900';

const WARNING_MESSAGE =
  'p-3.5 bg-red-50 border-l-4 border-l-red-500 rounded text-[0.875rem] text-red-800 ' +
  'leading-[1.5]'; /* #FEF2F2 / #EF4444 / #991B1B */

const MODAL_FOOTER = 'px-6 py-4 border-t border-t-gray-200 flex justify-end gap-3';

const BUTTON_BASE =
  'px-5 py-2.5 rounded-tasky-xs text-[0.875rem] font-medium cursor-pointer transition-all duration-200';
const BUTTON_DANGER =
  'border-0 bg-red-600 text-white hover:bg-red-700 disabled:bg-red-300 disabled:cursor-not-allowed'; /* #DC2626 / #B91C1C / #FCA5A5 */
const BUTTON_DEFAULT =
  'bg-white text-gray-700 border border-gray-300 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed'; /* #D1D5DB / #F9FAFB */

const DeleteChatModal: React.FC<DeleteChatModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  chatTitle,
  isDeleting = false,
}) => {
  if (!isOpen) {
    return null;
  }

  const handleConfirm = () => {
    console.log('モーダル削除確認クリック');
    onConfirm();
  };

  return (
    <div className={MODAL_BACKDROP} onClick={onClose}>
      <div className={MODAL_CONTENT} onClick={(e) => e.stopPropagation()}>
        <div className={MODAL_HEADER}>
          <h2 className={MODAL_TITLE}>
            <span className={WARNING_ICON}>⚠️</span>
            チャットを削除
          </h2>
        </div>

        <div className={MODAL_BODY}>
          <p className={MESSAGE}>
            <span className={CHAT_TITLE}>{chatTitle}</span> を削除してもよろしいですか？
          </p>

          <div className={WARNING_MESSAGE}>
            この操作は取り消せません。削除されたチャット履歴は復元できませんので、ご注意ください。
          </div>
        </div>

        <div className={MODAL_FOOTER}>
          <button className={`${BUTTON_BASE} ${BUTTON_DEFAULT}`} onClick={onClose} disabled={isDeleting}>
            キャンセル
          </button>
          <button className={`${BUTTON_BASE} ${BUTTON_DANGER}`} onClick={handleConfirm} disabled={isDeleting}>
            {isDeleting ? '削除中...' : '削除する'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteChatModal;
